<!--<c-footer>-->
  <div>
    <!-- <a href="https://coreui.io/" target="_blank">CoreUI</a> -->
    <span>2025 DigiHous</span>
  </div>
  <div class="ms-auto">
    Produzido por
    <a href="https://github.com/cleissonheggdorne" target="_blank">
      <span>Cleisson Heggdorne</span>
    </a>
  </div>
<!--</c-footer>-->
